export const Crest = ({ className = "" }) => (
  <svg viewBox="0 0 220 260" className={className} role="img" aria-label="Cypress Boys crest">
    <path
      d="M14 14 H206 V136 C206 194 166 228 110 246 C54 228 14 194 14 136 Z"
      fill="#17472F"
      stroke="#C9A227"
      strokeWidth="8"
      strokeLinejoin="round"
    />
    <path
      d="M30 30 H190 V134 C190 184 156 214 110 230 C64 214 30 184 30 134 Z"
      fill="none"
      stroke="#F0E6CE"
      strokeWidth="1.6"
    />
    <g stroke="#C9A227" strokeWidth="3" strokeLinecap="round">
      <line x1="48" y1="70" x2="96" y2="70" />
      <line x1="124" y1="70" x2="172" y2="70" />
    </g>
    <rect x="104" y="64" width="12" height="12" transform="rotate(45 110 70)" fill="#C9A227" />
    <text
      x="112"
      y="124"
      textAnchor="middle"
      fill="#F0E6CE"
      fontSize="30"
      fontWeight="700"
      letterSpacing="4"
      style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
    >
      CYPRESS
    </text>
    <g stroke="#C9A227" strokeWidth="3" strokeLinecap="round">
      <line x1="58" y1="142" x2="96" y2="142" />
      <line x1="124" y1="142" x2="162" y2="142" />
    </g>
    <rect x="105" y="137" width="10" height="10" transform="rotate(45 110 142)" fill="#C9A227" />
    <text
      x="118"
      y="192"
      textAnchor="middle"
      fill="#F0E6CE"
      fontSize="34"
      fontWeight="700"
      letterSpacing="16"
      style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
    >
      BOYS
    </text>
    <g stroke="#C9A227" strokeWidth="3" strokeLinecap="round">
      <line x1="68" y1="208" x2="96" y2="208" />
      <line x1="124" y1="208" x2="152" y2="208" />
    </g>
    <rect x="105" y="203" width="10" height="10" transform="rotate(45 110 208)" fill="#C9A227" />
  </svg>
);
